var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_12471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.7656C18.6274 24.7656 24 19.393 24 12.7656C24 6.13821 18.6274 0.765625 12 0.765625C5.37258 0.765625 0 6.13821 0 12.7656C0 19.393 5.37258 24.7656 12 24.7656Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48056 5.45978C1.53796 6.68617 0.827189 8.09968 0.41333 9.63526H6.65605L2.48056 5.45978Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5866 9.63528C23.1728 8.09975 22.4619 6.68623 21.5194 5.45984L17.344 9.63528H23.5866Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.41333 15.8961C0.827236 17.4316 1.538 18.8452 2.48056 20.0715L6.65591 15.8961H0.41333Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3058 3.2463C18.0794 2.30369 16.6659 1.59292 15.1304 1.17902V7.42169L19.3058 3.2463Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69409 22.285C5.92048 23.2276 7.334 23.9383 8.86953 24.3522V18.1096L4.69409 22.285Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86948 1.17902C7.33395 1.59292 5.92044 2.30369 4.69409 3.24625L8.86948 7.42164V1.17902Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 24.3522C16.6659 23.9383 18.0794 23.2276 19.3058 22.285L15.1304 18.1096V24.3522Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.344 15.8961L21.5194 20.0716C22.4619 18.8452 23.1728 17.4316 23.5866 15.8961H17.344Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 11.2004H13.5653H13.5653V0.867203C13.0529 0.8005 12.5305 0.765625 12 0.765625C11.4694 0.765625 10.9471 0.8005 10.4348 0.867203V11.2003V11.2004H0.101578C0.034875 11.7128 0 12.2351 0 12.7656C0 13.2962 0.034875 13.8185 0.101578 14.3308H10.4347H10.4347V24.664C10.9471 24.7308 11.4694 24.7656 12 24.7656C12.5305 24.7656 13.0529 24.7308 13.5652 24.664V14.3309V14.3309H23.8984C23.9651 13.8185 24 13.2962 24 12.7656C24 12.2351 23.9651 11.7128 23.8984 11.2004Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 15.8961L20.4852 21.2509C20.7315 21.0047 20.9664 20.7473 21.1906 20.4805L16.6061 15.8961H15.1304V15.8961Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86951 15.8961H8.86941L3.51465 21.2509C3.76084 21.4972 4.01823 21.7321 4.28504 21.9563L8.86951 17.3717V15.8961Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86951 9.63529V9.63519L3.5147 4.28033C3.26842 4.52652 3.03348 4.78391 2.80933 5.05072L7.39384 9.63524H8.86951V9.63529Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 9.63525L20.4852 4.28034C20.239 4.03406 19.9817 3.79912 19.7148 3.57501L15.1304 8.15953V9.63525Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_12471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.765625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/uk-flag.f15b12aea0173b3966739743bd947fcd.svg";
export { ForwardRef as ReactComponent };